export default {"src":"/_next/static/media/youtube.314f3fa9.svg","height":16,"width":22};